import { Action, Types } from './actions';

interface KeyState {
  inProgress: boolean;
  allowed?: boolean;
}

export interface State {
  initialised: boolean;
  keys: {
    [key: string]: KeyState;
  };
}

const InitialState: State = {
  initialised: false,
  keys: {},
};

export const reducer = (state: State = InitialState, action: Action): State => {
  switch (action.type) {
    case Types.INITIALISATION_COMPLETED:
      return {
        ...state,
        initialised: true,
      };

    case Types.KEY_STARTED:
      return {
        ...state,
        keys: {
          ...state.keys,
          [action.payload.key]: {
            inProgress: true,
          },
        },
      };

    case Types.KEY_COMPLETED:
      return {
        ...state,
        keys: {
          ...state.keys,
          [action.payload.key]: {
            inProgress: false,
            allowed: action.payload.allowed,
          },
        },
      };

    case Types.KEY_FAILED:
      return {
        ...state,
        keys: {
          ...state.keys,
          [action.payload.key]: {
            inProgress: false,
          },
        },
      };

    case Types.CLEAR:
      return {
        ...state,
        initialised: false,
        keys: {},
      };

    default:
      return state;
  }
};
